<div class="authentication-spinner-container">
    <div class="wrapper">
        <mat-spinner></mat-spinner>
        <span>{{ spinnerText | translate:locale.language }}</span>
    </div>
</div>